import Swiper, {Pagination, Navigation, Lazy} from "swiper";

Swiper.use([Pagination, Navigation, Lazy]);

const initJobSeekerSliders = () => {
   const sliderContainers = document.querySelectorAll('.job-seeker');
   sliderContainers.length && sliderContainers.forEach((sliderContainer) => {
      const slider = sliderContainer.querySelector('.job-seeker__slider');
 
      new Swiper(slider, {
         loop: true,
         lazy: true,
         effect: 'slide',
         slidesPerView: 1,
         spaceBetween: 10,
         autoHeight: true,
         navigation: {
            nextEl: sliderContainer.querySelector('.slider-navigation__button--next'),
            prevEl: sliderContainer.querySelector('.slider-navigation__button--prev'),
         },
         pagination: {
            el: sliderContainer.querySelector('.swiper-pagination'),
            type: "fraction",
         },
         a11y: {
            enabled: true,
            prevSlideMessage: 'Переход на предыдущий слайд',
            nextSlideMessage: 'Переход на следующий слайд',
         },
      });     
   });
 };

export default initJobSeekerSliders;
